// extracted by mini-css-extract-plugin
export default {"wrapper":"SaZH2OdfVh","title":"dtMDx9HbjY","description":"i0SJzF9Z8s","placeholder":"BZewhgcl5X","keys":"XauRyNh1vd","key":"Xm0diPHCQw","separator":"liaet0ifGX","dark":"hIRumLcnU6"};